import { some } from 'lodash';
import { getUidFromHref } from 'utils/stringHelper';

export const isPersonLinkWithOrg = (personId, linkedOrgAndPeopleList) => {
  return some(linkedOrgAndPeopleList, (val) => {
    return getUidFromHref(val.person.href) === personId;
  });
};
